import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import $ from "jquery";
import L from "leaflet";
import "leaflet-easybutton/src/easy-button.css";
import {
  Map,
  // TileLayer,
  ZoomControl,
  FeatureGroup,
  LayersControl,
  TileLayer,
  ScaleControl,
} from "react-leaflet";
import Control from "react-leaflet-control";
import MarkerClusterGroup from "react-leaflet-markercluster";
import "leaflet-easybutton";
import "leaflet-easybutton/src/easy-button.css";
import "leaflet/dist/leaflet.css";
import "react-leaflet-markercluster/dist/styles.min.css";
import { GeofenceBox, LayerBox, LegendBox } from "../../../component";
import IncidentControl from "./IncidentControl";
import MapControl from "./MapControl";
import {
  HeatMapComponent,
  MapMarkerComponent,
  DrawingManagerComponent,
  PolygonComponent,
  CircleMarkerComponent,
} from "../components";

import "./style.css";

import { tickerActions } from "../../../store/actions";
import { uavIcon } from "../../../utils/imageSource";

const { BaseLayer, Overlay } = LayersControl;

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

class LeafletMapComponent extends Component {
  // constructor(props){
  //   super(props);
  // }

  mapRef = createRef();
  state = {
    mapInstance: null,
    userLegendList: [
      {
        name: 'IED/VBIED',
        icon: 'fa fa-bomb'
      },
      {
        name: 'Isolated Gunfire',
        icon: 'fa fa-times-circle'
      },
      {
        name: 'Violent Clash',
        icon: 'fa fa-fire'
      },
      {
        name: 'Carjacking',
        icon: 'fa fa-car'
      },
      {
        name: 'Airstrike / UAV',
        icon: 'fa fa-fighter-jet'
      },
      {
        name: 'Mortar/Rocket',
        icon: 'fa fa-rocket'
      },
      {
        name: 'Kidnapping',
        icon: 'fa fa-child'
      },
      {
        name: 'Other',
        icon: 'fa fa-crosshairs'
      },
    ],
    icon: null,
    zoom:
      process.env.REACT_DEFAULT_ZOOM !== undefined
        ? process.env.REACT_DEFAULT_ZOOM
        : 8.45,
    bounds: null,
    showLayers: false,
  };

  componentDidMount() {
    this.setState({ showLayers: true });
    // map instance
    const mapInstance = this.refs.map.leafletElement;
    const bounds = this.refs.map.leafletElement.getBounds();

    /* BASE LAYER FOR STREET MAP VIEW */
    const Streetmap_url =
      "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}";
    L.tileLayer(Streetmap_url).addTo(mapInstance);

    /* SAVE MAP BOUNDS */
    this.setState({ mapInstance, bounds });
    const { sidebarOpen } = this.props;
    this.setState({ icon: !sidebarOpen ? "chevron-right" : "chevron-left" });
    $(".leaflet-control-layers-toggle").prepend(
      "<span>This is the span content</span>"
    );

    $(document).ready(function(){
      $(".leaflet-control-layers.leaflet-control").attr("data-tut", "map-layers");
      $('.leaflet-control-layers-selector:eq(1)').parent().after("<hr class='leaflet-line1'/>");
      $('.leaflet-control-layers-selector:eq(0)').parent().before("<p class='leaflet-gnk-short-txt'><i class='fe fe-help-circle only-slct1'></i> Only select one </p>");
    });
  }
  shouldComponentUpdate(nextProps, nextState) {
    return nextState.showLayers !== this.state.showLayers;
  }
  // SET BOUNDS LOGIC WILL BE ADDED HERE
  fitToCustomLayer = async () => {
    // const map = this.refs.map.leafletElement;
    // console.log(map);
    // var newParent = document.getElementsByClassName("custom-map-controls");
    // var oldParent = document.getElementsByClassName("leaflet-control-layers-overlays");
    // if (oldParent[0] !== undefined && newParent !== undefined) {
    //   for (var i = 0 ; i < oldParent[0].childNodes.length;  i++) {
    //     newParent[0].appendChild(oldParent[0].childNodes[i]);
    //   }
    // }
  };

  getClusterClass(markers) {
    let combinedMarker = false;
    // Disabling rule, because we need to break loop at specific condition
    for (const marker of markers) {
      // eslint-disable-line no-restricted-syntax
      if (marker.options.someMarkerCustomOption) {
        combinedMarker = true;
        break;
      }
    }

    return combinedMarker ? "combined" : "single";
  }
  //  SET ZOOM VIEW OF CALLED OBJECT
  zoomView = (e, map, zoomObject) => {
    const mapInstance = this.refs.map.leafletElement;
    let cM = mapInstance.project(map);
    const zoomLvl = zoomObject;
    mapInstance.setView(mapInstance.unproject(cM), zoomLvl, {
      animate: true,
      pan: {
        duration: 0.25,
        easeLinearity: 0.5,
      },
    });
  };

  componentWillReceiveProps(nextProps) {
    const mapInstance = this.refs.map.leafletElement;
    //ZOOM TO MARKER OR MY GEOFENCE
    const { zoomObject } = nextProps;
    if (this.props.zoomObject !== zoomObject && zoomObject !== undefined) {
      if (zoomObject.length > 2) {
        zoomObject.map((value) => this.zoomView(mapInstance, value, 9));
      } else {
        // Remove all previous highlighted zoom points
        $(".removeOnZoom").remove();
        // Create new highlighted zoom points
        L.circleMarker(zoomObject, {
          radius: 12,
          title: "zoomed",
          color: "black",
          className: "removeOnZoom",
        }).addTo(mapInstance);
        // Set zoom level
        this.zoomView(mapInstance, zoomObject, 15);
      }
    }
    //CHANGE SIDE BAR ICON UPON CURRENT STATE
    if (this.props.sidebarOpen !== nextProps.sidebarOpen) {
      const { sidebarOpen } = nextProps;
      this.setState({ icon: !sidebarOpen ? "chevron-right" : "chevron-left" });
    }
  }

  render() {
    const { bounds, zoom } = this.state;
    const markerclusterOptions = {
      iconCreateFunction: function (cluster) {
        return L.divIcon({ html: "<b>" + cluster.getChildCount() + "</b>" });
      },
      showCoverageOnHover: false,
      maxClusterRadius: 45,
      spiderfyDistanceMultiplier: 20,
    };
    const position =
      process.env.REACT_DEFAULT_POSITION_COORDS !== undefined
        ? process.env.REACT_DEFAULT_POSITION_COORDS
        : [27.3351, 17.2283];
    // PERMISSION FOR SUBSCRIPTION USERS
    let subscription = this.props.subscription;
    let localStorageSubscription = JSON.parse(
      localStorage.getItem("subscription_details")
    );
    let checkSubcriptionLevel =
      subscription === null ? localStorageSubscription : subscription;
      console.log(checkSubcriptionLevel)
    return (
      <>
        <Map
          ref="map"
          bounds={bounds}
          // Set latitude and longitude of the map center (required)
          center={position}
          minZoom={2}
          animate={true}
          maxZoom={18}
          // Set the initial zoom level, values 0-18, where 0 is most zoomed-out (required)
          zoom={zoom}
          scrollWheelZoom={true}
          zoomControl={false}
          attributionControl={false}
          onlayeradd={this.fitToCustomLayer}
          onlayerremove={this.fitToCustomLayer}
        >
          <Control position="topright">
            <GeofenceBox data-tut="geo-fence">
              <DrawingManagerComponent
                map={this.state.mapInstance}
                overlayRef={this.refs.drawingRef}
              />
            </GeofenceBox>
          </Control>
          <LayerBox>
            <LayersControl
              position="bottomright"
              ref="layerControl"
              collapsed={true}
            >
              {/* SET ZOOM CONTROL POSITION */}
              <Control position="bottomleft">
                <IncidentControl
                  map={this.state.mapInstance}
                  position="topleft"
                />
                <MapControl
                  map={this.state.mapInstance}
                  position="bottomleft"
                />
                {/* <ZoomBox  data-tut="zoom-control"> */}
                <ZoomControl position="bottomleft" />
                {/* </ZoomBox> */}
              </Control>
              {/* SET SCALE CONTROL POSITION */}
              <ScaleControl position="bottomleft" />
              {/* SET SIDEBAR CONTROL POSITION */}
              <Control position="topleft">{this.props.sidebarBtn}</Control>
              <Control position="bottomleft">
                  <div
                    className="info legend leaflet-control leaflet-father"
                  >
                   <a href="https://leafletjs.com/">Leaflet</a> | &copy;	<a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors
                  </div>
              </Control>
              <Control position="bottomright">
                <LegendBox data-tut="legend-control">
                  <div
                    className="info legend leaflet-control"
                    style={{ padding: "10px" }}
                  >
                    <i style={{ background: "#70AD25" }}></i> Low Impact
                    <br />
                    <i style={{ background: "#F49630" }}></i> Medium Impact
                    <br />
                    <i style={{ background: "#D13D29" }}></i> High Impact
                  </div>
                  {/* <div className="info legend leaflet-control"> 
                    
                    <i style={{ color: "#94a869" }} className="fa fa-bomb"></i>{" "}
                    IED/VBIED
                    <br />
                    <i
                      style={{ color: "#94a869" }}
                      className="fa fa-times-circle"
                    ></i>{" "}
                    Isolated Gunfire
                    <br />
                    <i
                      style={{ color: "#94a869" }}
                      className="fa fa-fire"
                    ></i>{" "}
                    Violent Clash
                    <br />
                    <i
                      style={{ color: "#94a869" }}
                      className="fa fa-car"
                    ></i>{" "}
                    Carjacking
                    <br />
                    <i
                      style={{ color: "#94a869" }}
                      className="fa fa-fighter-jet"
                    ></i>{" "}
                    Airstrike
                    <br />
                    <i
                      style={{ color: "#94a869" }}
                      className="fa fa-rocket"
                    ></i>{" "}
                    Mortar/Rocket
                    <br />
                    <i
                      style={{ color: "#94a869" }}
                      className="fa fa-crosshairs"
                    ></i>{" "}
                    Other
                    <br />
                    <i
                      style={{ color: "#94a869" }}
                      className="fa fa-plane"
                    ></i>{" "}
                    {/* <img src={uavIcon}/> */}
                    {/* UAV */}
                  {/* </div> */} 
                <ul className="info legend leaflet-control" style={{listStyleType: "none"}}>
                {this.state.userLegendList.map(function(obj, index){
                    return <li key={ index }>
                      <i className={obj.icon} style={{color: "#94a869"}}></i>
                      <span>{obj.name}</span>
                    </li>;
                  })}
                </ul>
                </LegendBox>
              </Control>
              {/* SET OVERLAYS */}
              

              {/* <BaseLayer name="Markers on/off" checked>
                <FeatureGroup>
                  <CircleMarkerComponent />
                </FeatureGroup>
              </BaseLayer> */}
              
              <Overlay name="Markers on/off" checked>
                <FeatureGroup>
                  <CircleMarkerComponent />
                </FeatureGroup>
              </Overlay>

              <Overlay name="Markers clusters on/off" ref="clustersRef">
              <FeatureGroup>
                  <MarkerClusterGroup
                    removeOutsideVisibleBounds={true}
                    options={markerclusterOptions}
                  >
                    <MapMarkerComponent />
                  </MarkerClusterGroup>
                </FeatureGroup>
              </Overlay>
              
              {/* <BaseLayer name="Markers clusters on/off" ref="clustersRef">
                <FeatureGroup>
                  <MarkerClusterGroup
                    removeOutsideVisibleBounds={true}
                    options={markerclusterOptions}
                  >
                    <MapMarkerComponent />
                  </MarkerClusterGroup>
                </FeatureGroup>
              </BaseLayer> */}
              
              <Overlay name="Heat Map on/off" ref="heatMapRef">
                <FeatureGroup>
                  <HeatMapComponent />
                </FeatureGroup>
              </Overlay>

              {/* <LayersControl.BaseLayer name="OpenStreetMap.BlackAndWhite">
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png"
                />
              </LayersControl.BaseLayer> */}

              {checkSubcriptionLevel?.subscription_level === null ||
              checkSubcriptionLevel?.subscription_level === 2 ? (
                <Overlay name="Geofencing ">
                  <FeatureGroup ref="polgonRef">
                    <PolygonComponent map={this.state.mapInstance} />
                  </FeatureGroup>
                </Overlay>
              ) : (
                ""
              )}

              {/* <Overlay name="Black and White View on/off" ref="heatMapRef">
                <FeatureGroup>
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png"
                />
                </FeatureGroup>
              </Overlay> */}

            </LayersControl>
          </LayerBox>
        </Map>
      </>
    );
  }
}
function mapStateToProps(state) {
  const { zoomObject, filterDataError, filterData } = state.map;
  const { subscription } = state.user;
  const { tickerData, sidebarOpen } = state.ticker;
  return {
    subscription,
    zoomObject,
    filterDataError,
    filterData,
    tickerData,
    sidebarOpen,
  };
}
const mapDispatchToProps = {
  onSetTickerOpen: tickerActions.onSetTickerOpen,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeafletMapComponent);
